// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"c0ac60b47de1cf73","5093":"5b70f0cdb507b3c9"}[chunkId] + ".css";
};